import { formatMobileNumber, validateMobileNumber } from "./common-utils";

export const AMENITY_KEYS = new Set([
    "BD_Clubhouse", "BD_SwimmingPool", "BD_Gym", "BD_ChildrenPlayArea",
    "BD_GardenPark", "BD_IndoorGames", "BD_SecurityCctv", "BD_PowerBackup",
    "BD_Lifts", "BD_VisitorParking", "BD_EvCharging", "BD_BusinessCentre"
]);

export function preparePostMetadata(formData, excludedMetadataObjectKeys = new Set()) {
    const amenities = formData.BD_Amenities || [];
    const baseMetadata = Object.entries(formData)
        .filter(entry => entry[0] !== 'BD_Amenities' && entry[0] !== 'org_name' && entry[0] !== 'name' && entry[0] !== 'subSubTitle' && entry[0] !== 'subsubtitle' && !excludedMetadataObjectKeys.has(entry[0]))
        .filter(entry => !entry[0].endsWith('_manualValue') && !entry[0].endsWith('_label'))
        .filter(entry => entry[1] !== undefined && entry[1] !== null && entry[1] !== "");

    const filteredBaseMetadata = baseMetadata.filter(entry => !AMENITY_KEYS.has(entry[0]));

    const result = filteredBaseMetadata.map((entry, index) => {
        const key = entry[0];
        const val = entry[1];
        const item = {
            listKey: { name: key },
            listValue: String(val),
            sequence: index + 1
        };
        if ((val === "-1" || val === -1 || val === "OTHER" || val === "Other") && formData[`${key}_manualValue`]) {
            item.manualValue = formData[`${key}_manualValue`];
        }
        return item;
    });

    let seq = result.length + 1;
    if (Array.isArray(amenities)) {
        amenities.forEach(amenity => {
            if (amenity) {
                result.push({
                    listKey: { name: amenity },
                    listValue: "true",
                    sequence: seq++
                });
            }
        });
    }

    return result;
}

export function pageData(state, isEditForm) {
    let data = {};
    
    if (typeof state === 'string') {
        data = JSON.parse(state);
        if (isEditForm) {
            data.categoryId = data?.item?.categoryId || -999;
            data.slug = data?.item?.categoryKey || "";
            return data;
        }
        data.categoryId = data?.item?.id || -999;
        data.slug = data?.item?.key || "";
        return data;
    }
    return data = { ...state, categoryId: state?.item.id || -999,slug: state?.item.key || "" };
}

export function assigneVerificationRequired(formData, userPhoneNumber) {
    if (formData.assigneeUserId && formData.assigneeUserId.trim() !== '' && validateMobileNumber(formData.assigneeUserId) && formatMobileNumber(formData.assigneeUserId) !== formatMobileNumber(userPhoneNumber)) {
        return true;
    }
    return false;
}

export function pushToArray(arr, key, value){
    arr.push({
      key: key,
      value: value,
    });
}

export function normalizePostType(value) {
    const normalized = String(value || "")
        .trim()
        .toLowerCase()
        .replace(/_/g, "-")
        .replace(/\s+/g, "-");

    if (normalized === "service-provider") return "service-provider";
    if (normalized === "dealer") return "dealer";
    if (normalized === "investor") return "investor";
    return "customer";
}
